var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "search-form",
              attrs: {
                inline: true,
                model: _vm.searchForm,
                size: "small",
                "label-width": "64px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "员工姓名" } },
                [
                  _c("el-autocomplete", {
                    staticClass: "inline-input",
                    attrs: {
                      "fetch-suggestions": _vm.querySearch,
                      placeholder: "请输入内容",
                      "trigger-on-focus": false,
                      clearable: "",
                    },
                    on: { select: _vm.handleSelect },
                    model: {
                      value: _vm.searchForm.reallyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "reallyName", $$v)
                      },
                      expression: "searchForm.reallyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属部门" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.options,
                      "show-all-levels": false,
                      props: {
                        checkStrictly: true,
                        label: "orgName",
                        value: "orgPath",
                        children: "children",
                      },
                      clearable: "",
                      filterable: "",
                    },
                    on: { change: _vm.handleSelectOrgId },
                    model: {
                      value: _vm.searchForm.orgId1,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orgId1", $$v)
                      },
                      expression: "searchForm.orgId1",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { float: "right", "margin-right": "0px" } },
                [
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "s-btn",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "r-btn",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "line" }),
          _c("div", { staticClass: "data-title" }, [
            _c(
              "div",
              { staticStyle: { display: "flex", height: "32px" } },
              [
                _c(
                  "el-tabs",
                  {
                    staticClass: "custom-tabs1",
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: {
                        label: "已离职（" + _vm.totalNum + "）",
                        name: "1",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "title-btn" }, [
              _c(
                "div",
                {
                  staticClass: "title-btn-item",
                  staticStyle: { "margin-right": "12px" },
                  on: {
                    click: function ($event) {
                      return _vm.deliverData()
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "16px", height: "16px" },
                    attrs: { src: require("../../../assets/icon_daochu.png") },
                  }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("导出列表")]),
                ]
              ),
            ]),
          ]),
          _c("lb-table", {
            directives: [
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: "'always'",
              },
            ],
            attrs: {
              column: _vm.columns,
              data: _vm.list,
              pagination: "",
              total: _vm.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.pageNo,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "selection-change": _vm.onMultipleSelection,
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("view-employment", { ref: "viewEmployment" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }